import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// ==============================|| GUEST GUARD ||============================== //

interface Props {
  children: React.ReactElement | null;
}

export default function GuestGuard({ children }: Props) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && isLoggedIn) {
      navigate('/dashboard', { replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized) return <Loader />;
  if (isLoggedIn) return null;

  return children;
}
